export default __webpack_public_path__ + "static/media/Agenda_title_normal.a530e0ba.svg";